import ElegantInputWithTagging from './ElegantInputWithTagging'

export default ElegantInputWithTagging
